import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  Component,
  inject,
  input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PropertyBean, PropertyMatchBean } from '@ui/shared/model';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {
  ActionState,
  AddressPipe,
  FormFieldComponent,
  FormFieldLabelComponent,
  isPropertyTypeCommercial,
  isPropertyTypeFlat,
  isPropertyTypeGarage,
  LoadingSpinnerComponent,
  ModalContentComponent,
  ModalV2Component,
  SlideToggleComponent
} from '@ui/legacy-lib';
import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SvgIconComponent } from 'angular-svg-icon';
import { SearchProfileStore } from '@ui/tenant-pool/shared/search-profile/data-access';
import {
  getPropertyMatchesData,
  getPropertyMatchesDataActionState
} from '../../+state/property-matches/property-matches.selector';
import { LoadPropertyMatchesBeans } from '../../+state/property-matches/property-matches.actions';

@Component({
  selector: 'app-tenant-acceptance-modal',
  templateUrl: './tenant-acceptance-modal.component.html',
  styleUrls: ['./tenant-acceptance-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    LottieComponent,
    SvgIconComponent,
    FormsModule,
    TranslatePipe,
    AsyncPipe,
    CurrencyPipe,
    AddressPipe,
    ModalV2Component,
    ModalContentComponent,
    FormFieldLabelComponent,
    FormFieldComponent,
    SlideToggleComponent,
    LoadingSpinnerComponent
  ]
})
export class TenantAcceptanceModalComponent implements OnInit {
  readonly property = input<PropertyBean>(undefined);
  public lottieConfig: AnimationOptions;
  public activateSearchProfile = false;
  public closeOpenApplication = true;
  public propertiesMatches$: Observable<PropertyMatchBean[]>;
  public propertiesMatchesActionState$: Observable<ActionState>;
  private ngbActiveModal = inject(NgbActiveModal);
  private store = inject(Store);
  private searchProfileStore = inject(SearchProfileStore);
  public readonly searchProfiles = this.searchProfileStore.searchProfiles;
  public readonly searchProfilesActionState =
    this.searchProfileStore.loadSearchProfilesActionState;

  public get isFlat() {
    return isPropertyTypeFlat(this.property()?.type);
  }

  public get isGarage() {
    return isPropertyTypeGarage(this.property()?.type);
  }

  public get isCommercial() {
    return isPropertyTypeCommercial(this.property()?.type);
  }

  public get haveFunWithPropertyTranslation() {
    return this.isFlat
      ? 'new-home.have_fun_with_new_flat_l'
      : this.isCommercial
        ? 'new-home.have_fun_with_new_commercial_l'
        : this.isGarage
          ? 'new-home.have_fun_with_new_garage_l'
          : '';
  }

  public get picture() {
    const property = this.property();
    return property?.titleImage || property?.data?.attachments?.[0];
  }

  ngOnInit() {
    this.searchProfileStore.loadSearchProfiles({});
    this.store.dispatch(
      LoadPropertyMatchesBeans({
        data: { page: 0, size: 15, sort: 'id,asc' },
        loadMore: false
      })
    );
    this.propertiesMatches$ = this.store
      .select(getPropertyMatchesData)
      .pipe(shareReplay(1));
    this.propertiesMatchesActionState$ = this.store.select(
      getPropertyMatchesDataActionState
    );

    this.lottieConfig = {
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/data.json' // the path to the animation json
    };
  }

  public dismiss() {
    this.ngbActiveModal.dismiss();
  }

  public close() {
    this.ngbActiveModal.close({
      activateSearchProfile: this.activateSearchProfile,
      closeOpenApplication: this.closeOpenApplication
    });
  }
}
